const config = {
  contactKeys: {
    billing: {
      billing_title: 'contact_title',
      billing_first_name: 'contact_first_name',
      billing_name: 'contact_name',
      billing_address_number: 'address_number',
      billing_address_street: 'address_street',
      billing_postcode: 'postcode',
      billing_address_city: 'address_city',
      billing_company_name: 'company_name',
      billing_vat_number: 'vat_number',
      billing_country: 'country',
    },
    follow_up: {
      contact_follow_up_title: 'contact_title',
      contact_follow_up_first_name: 'contact_first_name',
      contact_folluw_up_name: 'contact_name',
      contact_follow_up_email: 'contact_email',
      contact_follow_up_phone: 'contact_phone',
    },
  },
};

export default config;
